import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor( public breakpointObserver : BreakpointObserver) {

    
   }


   isHandset(){
    return  this.breakpointObserver.observe(['(max-width: 600px)'])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
   }
}
